import * as ToolStorage from './ToolStorage';

// Load official antd dark CSS as a static asset so it can be toggled on/off
// eslint-disable-next-line import/no-webpack-loader-syntax
const antdDarkCssHref = require('!!file-loader?name=static/css/antd.dark.[hash:8].css!antd/dist/antd.dark.min.css');

export const applyDarkMode = (enabled) => {
	document.body.classList.toggle('dark-mode', enabled);

	let link = document.getElementById('antd-dark-theme');
	if (enabled) {
		if (!link) {
			link = document.createElement('link');
			link.id = 'antd-dark-theme';
			link.rel = 'stylesheet';
			link.href = antdDarkCssHref;
			document.head.appendChild(link);
		}
	} else if (link) {
		link.remove();
	}
};

export const getDarkMode = () => !!ToolStorage.get('darkMode', false);

export const setDarkMode = (enabled) => {
	ToolStorage.set('darkMode', enabled);
	applyDarkMode(enabled);
};

export const initDarkMode = () => {
	applyDarkMode(getDarkMode());
};
